import { Fragment } from "react";
import { Waypoint } from "react-waypoint";

import Typography  from "_components/atoms/typography";
import CreatorCard from "_components/molecules/creatorCard";
import useStyles   from "_styles/organisms/popularStreamers";

const component = props => {

	const {
		 activeTab,
		 streamersList,
		 isDataDepleted,
		 isFetchingData,
		 getNextData,
		changeTab,
		disableInfiniteScroll,
		searchQuery
		 } = props;

	const { classes } = useStyles ( { activeTab, streamersList } );

	const heading = `Popular ${ searchQuery } Streamers`;

	return (
		<div className = { classes.popularContentWrapper }>
			{activeTab !== "people" && (
				<Typography
					className = { classes.heading }
					title     = { heading }
				/>
			)}

			{streamersList?.map ( ( streamerInfo, idx, arr ) => {
				const showViewAll = activeTab !== "people" && idx <= 2 && idx === ( arr.length - 1 );

				return (
					<Fragment key = { streamerInfo.id }>

						<CreatorCard
							key  = { idx }
							data = { streamerInfo }
						/>

						{ !disableInfiniteScroll && !isDataDepleted && !isFetchingData && streamersList.length > 0 && idx === streamersList.length - 2 && (
							<Waypoint
								onEnter = { () => getNextData () }
							/>
						)}

						{showViewAll ? (
							<div className = { classes.viewAll }
								onClick       = { () => {
									changeTab ( "people" );
								} }
							>
								View All
							</div>
						) : null}
					</Fragment>
				);
			} )}

		</div>
	);
};

export default component;
